import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#545454] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="relative p-2 bg-white rounded-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a8f39fa2-260f-4b5d-ae2d-449c88927f46/artifacts/0c714myo_high%20res%20logo%20cropped.png" 
                alt="Pathway Home Lending" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 text-sm">
              Veteran-owned mortgage brokerage serving Colorado and beyond. 
              Your pathway to homeownership starts here.
            </p>
            <div className="text-sm text-gray-400">
              NMLS 2032871
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300">
                  1499 W 120th Ave Suite 110<br />
                  Westminster, CO 80234
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span className="text-gray-300">(720) 650-7988</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Services</h3>
            <div className="space-y-2 text-sm">
              <Link to="/loan-programs" className="block text-gray-300 hover:text-white transition-colors">
                Loan Programs
              </Link>
              <Link to="/team" className="block text-gray-300 hover:text-white transition-colors">
                Our Team
              </Link>
              <Link to="/calculators" className="block text-gray-300 hover:text-white transition-colors">
                Calculators
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Resources</h3>
            <div className="space-y-2 text-sm">
              <Link to="/events" className="block text-gray-300 hover:text-white transition-colors">
                Events
              </Link>
              <Link to="/education" className="block text-gray-300 hover:text-white transition-colors">
                Education
              </Link>
              <Link to="/privacy" className="block text-gray-300 hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center text-sm text-gray-300">
          <p>&copy; 2025 Pathway Home Lending. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;